module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_9016.929e096f.png";